<!-- Locations Wrapper Start -->
<div class="section">
    <div class="container locations-wrapper">
        <div class="location-item" *ngFor="let item of locations">
            <div class="row">
                <div class="col-md-6">
                    <div class="location-item-inner">
                        <img [src]="item.img" alt="{{item.title}}">
                        <div class="location-desc">
                            <h3>{{item.title}}</h3>
                        </div>
                        <div class="location-info">
                            <div class="row">
                                <div class="col-12">
                                    <div class="ct-info-box">
                                        <i class="flaticon-location"></i>
                                        <h5>Notre adresse</h5>
                                            <span *ngFor="let item of item.location">{{item}}</span>
                                            <span> Appelez-nous:<a href="tel:{{item.contactno}}">{{item.contactno}}</a> </span>
                                            <span> Enovoyez-nous un email:<a href="mailto:{{item.emailid}}">{{item.emailid}}</a> </span>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                        <div class="ct-contact-map-wrapper">
                            <div class="ct-contact-map" leaflet [leafletOptions]="options" (leafletMapReady)="onMapReady($event)"></div>
                            <a href="https://maps.app.goo.gl/xLd28yLQXV3miYJz7" target="_blank" class="btn-custom shadow-none">Voir sur google maps</a>
                        </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Locations Wrapper End -->